import {
  useState,
} from 'react';
import {
  Button,
  Checkbox,
  Form,
  Modal,
  Spin,
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import qs from 'query-string';
import { useSelector } from 'react-redux';
import { getArea, getDictType } from '@/services/common';
import {
  addApply, getBasicInfo, getMinorityArea,
} from '@/services/largeGrainGrower';
import './index.less';
import SubjectBasicInfo from './components/SubjectBasicInfo';
import useKeepAlive from '@/hooks/useKeepAlive';
import { LGG_ACCOUNT_TYPE, LGG_MANAGER_TYPE } from '@/utils/mappingDict';

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 24 },
  },
};
const defaultParams = [LGG_ACCOUNT_TYPE, LGG_MANAGER_TYPE].join(',');
export default function Application() {
  const [form] = Form.useForm();
  const Navigate = useNavigate();
  const { search, state: passedState } = useLocation();
  const { id } = qs.parse(search);
  const { userType } = useSelector((state) => state);
  const user = useSelector((state) => state.userInfo);

  const [initialValues] = useState({
    applicantName: userType === 2 ? user.realName : user.displayName,
    applicantNo: userType === 2 ? user.idcardNo : user.displayCode,
    applicationYear: passedState?.year,
  });

  const [authInfoModal, setAuthInfoModal] = useState(false); // 授权书内容

  const { data: dict = {} } = useRequest(getDictType, { defaultParams: [defaultParams] });
  const { data: minorityArea = [] } = useRequest(getMinorityArea); // 名族地区区域

  // 数据回显
  const { run: getBasicInfoRun } = useRequest(getBasicInfo, {
    manual: true,
    onSuccess(res) {
      if (res) {
        // 将获取的基本信息填充到申报主体信息相关字段
        form.setFieldsValue({
          // 申报主体基本信息字段
          applicantName: res.applicantName || (userType === 2 ? user.realName : user.displayName),
          applicantNo: res.applicantNo || (userType === 2 ? user.idcardNo : user.displayCode),
          registrationLocation: [String(res.provinceId), String(res.cityId), String(res.areaId)],
          detailAddress: res.detailAddress,
          managementEntityType: res.managementEntityType ? String(res.managementEntityType) : undefined,
          applicationYear: res.applicationYear || passedState?.year,
          contactor: res.contactor,
          telephone: res.telephone,
          depositBank: res.depositBank,
          bankCardAccount: res.bankCardAccount,
          accountType: res.accountType ? String(res.accountType) : undefined,
          remark: res.remark,
        });
      }
    },
  });

  const { data: area = [] } = useRequest(getArea, {
    onSuccess() {
      // 区域数据加载完成后，如果有年度参数则获取基本信息进行回显
      if (passedState?.year) {
        getBasicInfoRun(passedState?.year);
      }
    },
  }); // 区域

  const { loading, run: add } = useRequest(addApply, {
    manual: true,
    onSuccess() {
      Navigate('/result');
    },
  });

  // 保证token不过期
  useKeepAlive();

  function onFinish() {
    form.validateFields().then((values) => {
      const val = {
        ...values,
        provinceId: values.registrationLocation[0],
        cityId: values.registrationLocation[1],
        areaId: values.registrationLocation[2],
        registrationLocation: undefined,
        largegrainGrowerId: id,
      };
      add(val);
    }).catch(() => {
      setTimeout(() => {
        const errorList = document.querySelectorAll('.ant-form-item-has-error');
        errorList[0]?.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      }, 500);
    });
  }

  function checkAuthorize(_, value) {
    if (!value) {
      return Promise.reject(new Error('勾选同意并接受'));
    }
    return Promise.resolve();
  }

  return (
    <div className="major-financing-application">
      <div className="content-width">
        <div className="margin-top20">
          <Spin spinning={false}>
            <Form
              {...formItemLayout}
              form={form}
              name="form"
              className="form"
              onFinish={onFinish}
              initialValues={initialValues}
            >
              <SubjectBasicInfo
                formRef={form}
                initialValues={initialValues}
                dict={{
                  ...dict, area, userType, minorityArea,
                }}
              />
              <div className="authorize">
                <Form.Item
                  required
                  name="authorize"
                  wrapperCol={{ span: 24 }}
                  valuePropName="checked"
                  rules={[
                    { validator: checkAuthorize },
                  ]}
                >
                  <Checkbox
                    onChange={(e) => {
                      form.setFieldsValue({ authorize: false });
                      if (e.target.checked) {
                        setAuthInfoModal(true);
                      }
                    }}
                  >
                    同意并接受
                    <Button type="link" className="authorize-name" onClick={() => setAuthInfoModal(true)}>《承诺函》</Button>
                  </Checkbox>
                </Form.Item>
              </div>
              <div className="submit-btn-box">
                <Button type="primary" onClick={onFinish} loading={loading}>
                  提交申请
                </Button>
              </div>
            </Form>
          </Spin>
          <Modal
            title="承诺函"
            open={authInfoModal}
            footer={
              [
                <Button key="skip" onClick={() => setAuthInfoModal(false)}>
                  取消
                </Button>,
                <Button
                  type="primary"
                  key="confirm"
                  onClick={() => {
                    setAuthInfoModal(false);
                    form.setFieldsValue({ authorize: true });
                  }}
                >
                  确认
                </Button>,
              ]
            }
            onCancel={() => setAuthInfoModal(false)}
          >
            <div>
              本人（企业、合作社） 承诺在申报
              {passedState?.year}
              年种粮大户补贴时提交的所有材料真实、合法、有效，若发现材料存在虚假、瞒报等情况，
              本人（企业、合作社）自愿放弃本次申报，并退还获得的财政补贴资金，并承担违规违法责任。
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
}
